<table class="table participants">
    <thead>
        <tr>
            <th></th>
            <th>{{ 'full-data.account-number' | translate }}</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>
                <i class="icon-bank"></i>
            </td>
            <td>
                <span *ngIf="iban">{{ iban }}</span>
                <span *ngIf="!iban">{{ 'general.pending' | translate }}</span>
            </td>
        </tr>
    </tbody>
</table>
